import { useAppScopeStore } from '@frontend/scope';
import { useSelectedLocationContext } from '../../providers';
import { useMemoizedArray } from '../use-memoized-array';

/**
 * This hook returns a array of locations provided to the `SelectedLocationProvider` or falls back to the global location selection.
 * For the `selectedLocationIds`, please use `useAppScopeStore` instead.
 */
export const useSelectedLocations = () => {
  const selectedLocation = useSelectedLocationContext();
  const { selectedLocationIds } = useAppScopeStore();

  const locationIds = useMemoizedArray(selectedLocation ? selectedLocation : selectedLocationIds);

  return {
    locationIds,
  };
};
